// ABOUTME: Labeled section divider for product info forms.
// ABOUTME: Renders a small Chip label followed by a horizontal Divider filling the row.
import { Box, Chip, Divider } from '@ds/coolshop';

export const SectionDivider = ({ label }: { label: string }) => (
    <Box display="flex" alignItems="center" gap={1}>
        <Chip label={label} size="small" />
        <Box flex={1}>
            <Divider />
        </Box>
    </Box>
);
